import React, { useRef } from 'react'
import { COLORS } from 'tokens'
import { useUpcoming } from './useUpcoming'
import AppointmentCard from '../../../../components/AppointmentCard/AppointmentCard'
import { useShopPatientIds } from '../../../../hooks/useShopPatientIds'
import { shouldShowGreenBg } from '../../../../utils/shouldShowGreenBg'
import { getVisitBadges } from '../getVisitBadges'
import { TimeSection, Label, ColumnCard, ColumnHeader, Title, Count, ColumnFill, ColumnContent } from '../index.styled'

export default function UpcomingPanel({ data }: { data: any[] }) {
  const { scrollRef, navigate, handleLongPressStart, handleLongPressEnd } = useUpcoming()
  const shopPatientIds = useShopPatientIds()

  return (
    // <Column>
    <ColumnCard>
      <ColumnHeader>
        <Title>Upcoming</Title>
        <Count>{data.length}</Count>
      </ColumnHeader>
      <ColumnContent
        ref={scrollRef}
        onScroll={(e) => {
          const target = e.currentTarget
          localStorage.setItem('lobby-upcoming-scroll', String(target.scrollTop))
        }}
      >
        {data.map((d, index) => (
          <TimeSection key={d.visitId}>
            {d.showTimeStamp && (
              <Label style={{ marginTop: index !== 0 ? '16px' : '' }}>
                {d.visit?.appointmentTime ? d.timeStamp : '-'}
              </Label>
            )}

            <AppointmentCard
              key={d.visit?.id || d.visitId}
              name={`${d.visit?.patient?.user?.firstname || ''} ${d.visit?.patient?.user?.lastname || ''}`.trim()}
              avatar={d.visit?.patient?.user?.profilePic || undefined}
              badges={getVisitBadges(d, {
                isUpcomingOrCheckedIn: true,
                hasShopOrder: shopPatientIds.has(d.visit?.patientId),
              })}
              onClick={() => {
                navigate(`/patient-detail/${d.visit?.id}`)
              }}
              onMouseDown={() => handleLongPressStart(d)}
              onMouseUp={handleLongPressEnd}
              onMouseLeave={handleLongPressEnd}
              onTouchStart={() => handleLongPressStart(d)}
              onTouchEnd={handleLongPressEnd}
              cardStyle={{
                backgroundColor: shouldShowGreenBg(d) ? COLORS.primary : '',
                marginTop: !d.showTimeStamp ? '8px' : '',
                cursor: 'pointer',
              }}
              nameStyle={{
                color: shouldShowGreenBg(d) ? COLORS.textSecondary : '',
              }}
            />
          </TimeSection>
        ))}

        <ColumnFill />
      </ColumnContent>
    </ColumnCard>
    // </Column>
  )
}
